import { logUsage } from 'owa-analytics';
import { ClientItem, mailStore } from 'owa-mail-store';

export default function logAttachButtonClickedDatapoint(referenceItemId: string): void {
    // Get reference item (if any).
    const referenceItem: ClientItem = mailStore.items.get(referenceItemId);

    // Log that the Attach button itself was clicked.
    logUsage('AttachButtonClicked', [
        true /* isMail */,
        referenceItem &&
            referenceItem.SmartDocData &&
            referenceItem.SmartDocData.EntityId /* for SmartDoc pill */,
    ]);
}
